import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../apiconfig";
import { FaDownload } from "react-icons/fa";
import logoutUser from "./logoutUser";
import { useNavigate } from "react-router-dom";

function ApplicationReport() {
	
	
	const navigate = useNavigate();
	const [selectedProgram, setSelectedProgram] = useState("");
	const [alertData, setAlertData] = useState(null);

		const showAlert = (message, type = "error") => {
			setAlertData({
				message,
				type,
				id: Date.now()
			});

			setTimeout(() => {
				setAlertData(null);
			}, 5000); // match your CSS fadeOut timing
		};
		
	useEffect(() => {
		const fetchProgram = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PROGRAM`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("selected program is:", data);

				if (data) {
					setSelectedProgram(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch program", err);
			}
		};

		fetchProgram();
	}, []);
	
	const handleDownload = async () => {
		try {

			const token = sessionStorage.getItem("token");

			const response = await fetch(
				`${API_BASE_URL}/API/Student/DOWNLOAD_APPLICATION_PRINT`,
				{
					method: "POST",
					headers: {
						"Authorization": "Bearer " + token
					}
				}
			);

			if (response.status === 401) {

				sessionStorage.clear();

				showAlert("Session expired ❗ Please login again", "error");

				setTimeout(() => {
					window.location.href = "/ASTU_JMEE_JLEE/Login";
				}, 1000);

				return;
			}

			if (!response.ok) {
				throw new Error("Failed to download PDF");
			}

			const blob = await response.blob();

			const url = window.URL.createObjectURL(blob);

			const link = document.createElement("a");

			link.href = url;

			link.download = "ApplicationReport.pdf";

			document.body.appendChild(link);

			link.click();

			link.remove();

			window.URL.revokeObjectURL(url);

			showAlert("Application downloaded successfully ✅", "success");

		} catch (err) {

			console.error(err);

			showAlert("Error downloading application print ❗", "error");
		}
	};
	
	const [isPaymentDone, setIsPaymentDone] = useState(false);

		useEffect(() => {
			const checkPaymentStatus = async () => {
				try {
					const token = sessionStorage.getItem("token");

					const response = await fetch(
						`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
						{
							method: "GET",
							headers: {
								"Authorization": "Bearer " + token
							}
						}
					);

					if (response.status === 401 || response.status === 403) {

						logoutUser(navigate);
						return;
					}

					if (!response.ok) {
						console.error("Failed to fetch program");
						return;
					}


					if (!response.ok) return;

					const result = await response.json(); // boolean true/false
					console.log("Payment Done:", result);

					setIsPaymentDone(result);

					if (result) {
						showAlert(
							"Payment already completed ✅. Please download the Application Print-Out.",
							"success"
						);

						
					}
					else {

						showAlert(
							`Payment not done yet❗`,
							"error"
						);
					}

				} catch (error) {
					console.error("Error checking payment:", error);
				}
			};

			checkPaymentStatus();
		}, []);


	return (
		<>
			<style>{`

				@keyframes smoothEntry {
				0% {
				  opacity: 0;
			      transform: translateY(20px);
				  }
				 100% {
			      opacity: 1;
			      transform: translateY(0);
				  }
				}

				.application-report-wrapper{
				    width: 100%;
				    padding: 20px;
				    box-sizing: border-box;
				}

				.application-report-container{
				    max-width: 1100px;
				    margin: auto;

				    background: #ffffff;
				    border-radius: 16px;

				    padding: 25px;

				    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
				    border: 1px solid #edf2f7;
					animation: smoothEntry 0.4s ease;
				}

				.report-title{
				    font-size: 26px;
				    font-weight: 700;
				    margin-bottom: 24px;
				    color: #0d47a1;
				}

				.download-card{
				    display: flex;
				    justify-content: space-between;
				    align-items: center;

				    background: #f8fbff;
				    border-radius: 14px;

				    padding: 22px;

				    border: 1px solid #dbeafe;
				}

				.download-left h3{
				    margin: 0;
				    font-size: 18px;
				    color: #222;
				}

				.download-left p{
				    margin-top: 6px;
				    color: #666;
				    font-size: 14px;
				    line-height: 1.5;
				}

				.download-btn{
				    display: flex;
				    align-items: center;
				    gap: 8px;

				    background: linear-gradient(135deg, #1565c0, #0d47a1);
				    color: white;

				    border: none;
				    border-radius: 10px;

				    padding: 12px 22px;

				    font-size: 15px;
				    font-weight: 600;

				    cursor: pointer;
				    transition: 0.3s ease;
				}

				.download-btn:hover{
				    transform: translateY(-2px);
				    box-shadow: 0 6px 16px rgba(13, 71, 161, 0.25);
				}

				@media(max-width:768px){

				    .application-report-wrapper{
				        padding: 12px;
				    }

				    .application-report-container{
				        padding: 18px;
				    }

				    .download-card{
				        flex-direction: column;
				        align-items: flex-start;
				        gap: 18px;
				    }

				    .download-btn{
				        width: 100%;
				        justify-content: center;
				    }
				}

			`}</style>
			
			{alertData && (
							<div className={`custom-alert ${alertData.type}`}>
								<span className="alert-icon">
									{alertData.type === "success" ? "✔" : "❗"}
								</span>
								{alertData.message}
							</div>
						)}

						<div className="application-report-wrapper">

							<div className="application-report-container">

								<h2 className="report-title">
									Application Print
								</h2>

								<div className="download-card">

									<div className="download-left">

										<h3>
											Download Application Print
										</h3>

										<p>
											Programme: <strong>{selectedProgram}</strong>
										</p>

										{isPaymentDone ? (

											<p
												style={{
													marginTop: "10px",
													color: "#2e7d32",
													fontWeight: "600",
													fontSize: "14px"
												}}
											>
												✅ Payment completed successfully. You can download the application print.
											</p>

										) : (

											<p
												style={{
													marginTop: "10px",
													color: "#d32f2f",
													fontWeight: "600",
													fontSize: "14px"
												}}
											>
												❗ Payment not done yet for {selectedProgram}
											</p>

										)}

									</div>

									<button
										className="download-btn"
										onClick={handleDownload}
										disabled={!isPaymentDone}
										style={{
											opacity: !isPaymentDone ? 0.6 : 1,
											cursor: !isPaymentDone ? "not-allowed" : "pointer"
										}}
									>
										<FaDownload />
										<span>Download</span>
									</button>

								</div>

							</div>

						</div>
		</>
	);
}

export default ApplicationReport;